import dotProp from 'dot-prop-immutable'
import { connect } from 'react-redux'
import { toggleNavigationPhotos } from '../../actions/sidebar'
import { IconElement } from '../../components/FrameMenu/index'
import getPhotos from '../../repositories/getPhotos'

const mapStateToProps = state => ({
  isSelected: dotProp.get(state, 'sidebar.photos.isToggled', false),
})

const mapDispatchToProps = dispatch => ({
  action: () => dispatch(toggleNavigationPhotos(getPhotos(fetch))),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IconElement)



// WEBPACK FOOTER //
// ./src/containers/FrameMenu/SelectPhoto.js